import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { getAgreementParagraphs } from "./agreementContent";
import RichText from "./RichText";
import styles from "./AgreementPage.module.css";

// Standalone, public agreement page rendered at /terms. Linked from the landing
// footer and the in-app sidebar (both open it in a new tab) so users can always
// review the current "Gridsoft" MMC User Agreement & Privacy Policy.
const AgreementPage = () => {
  const { t, i18n } = useTranslation();
  const paragraphs = getAgreementParagraphs(i18n.language);

  useEffect(() => {
    const previous = document.title;
    document.title = t("legal.agreementLinkLabel");
    return () => {
      document.title = previous;
    };
  }, [t]);

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <img className={styles.logo} src="/gredus-logo.svg" alt="Gredus" />
          <h1 className={styles.title}>{t("legal.agreementLinkLabel")}</h1>
        </header>

        <article className={styles.body}>
          {paragraphs.map((paragraph, i) => (
            <p key={i} className={styles.paragraph}>
              <RichText text={paragraph} />
            </p>
          ))}
        </article>
      </div>
    </div>
  );
};

export default AgreementPage;
